/**
 * Iron Coffee Shopify Theme JavaScript
 */

(function() {
  'use strict';

  // Mobile Menu Toggle
  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  
  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener('click', function() {
      const isOpen = mobileMenu.classList.toggle('is-open');
      const icon = this.querySelector('svg');
      
      // Update icon
      if (isOpen) {
        icon.innerHTML = '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>';
      } else {
        icon.innerHTML = '<line x1="4" x2="20" y1="12" y2="12"></line><line x1="4" x2="20" y1="6" y2="6"></line><line x1="4" x2="20" y1="18" y2="18"></line>';
      }
      
      // Update aria-expanded
      this.setAttribute('aria-expanded', isOpen);
    });

    // Close menu when clicking on links
    const mobileMenuLinks = mobileMenu.querySelectorAll('a');
    mobileMenuLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        mobileMenu.classList.remove('is-open');
        mobileMenuToggle.setAttribute('aria-expanded', 'false');
        const icon = mobileMenuToggle.querySelector('svg');
        icon.innerHTML = '<line x1="4" x2="20" y1="12" y2="12"></line><line x1="4" x2="20" y1="6" y2="6"></line><line x1="4" x2="20" y1="18" y2="18"></line>';
      });
    });
  }

  // Newsletter Form Submission
  const newsletterForm = document.querySelector('[data-newsletter-form]');
  
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const emailInput = this.querySelector('input[type="email"]');
      const email = emailInput.value;
      
      // In a real implementation, this would submit to Shopify's customer API
      // For now, we'll just show a success message
      alert('Thanks for subscribing with: ' + email);
      emailInput.value = '';
    });
  }

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');
      
      if (targetId === '#') return;
      
      const target = document.querySelector(targetId);
      
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // Header scroll effect
  const header = document.querySelector('.header');
  
  if (header) {
    let lastScroll = 0;
    
    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;
      
      if (currentScroll > 50) {
        header.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.1)';
      } else {
        header.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
      }
      
      lastScroll = currentScroll;
    });
  }

  // Stock status: show today's date, and the visitor's city/state when available
  // (e.g. "In Stock - Available to ship to Austin, TX — Jan 9")
  const stockStatus = document.querySelector('[data-stock-status]');

  if (stockStatus) {
    const escapeHtml = function(s) {
      return String(s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    };

    // Today's date in the browser's locale, e.g. "Jan 9"
    var today = new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

    // Always show an accurate date (overrides any cached server date)
    stockStatus.innerHTML = 'In Stock - Available to Ship <strong>' + today + '</strong>';

    fetch('https://ipwho.is/')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var state = data && (data.region_code || data.region);
        if (data && data.success && data.city && state) {
          stockStatus.innerHTML = 'In Stock - Available to ship to <strong>' +
            escapeHtml(data.city) + ', ' + escapeHtml(state) + '</strong> — <strong>' + today + '</strong>';
        }
      })
      .catch(function() { /* keep the date-only line already set */ });
  }
})();

/**
 * Page tone. The page background is one gradient down the whole document
 * (html in theme.css), so text further down sits on darker grey. Every piece
 * of text that sits directly on that gradient gets a tone-* class picked from
 * the grey right behind it. Text inside cards, buttons and other blocks with
 * their own background is left alone.
 */
(function() {
  'use strict';

  // Mirrors the html gradient in theme.css: [position 0-1, grey 0-255].
  var STOPS = [[0, 255], [1, 230]];
  // [darker than this grey, class]. See the .tone-* rules in theme.css.
  var TONES = [[90, 'tone-dark'], [119, 'tone-light'], [155, 'tone-deep'], [250, 'tone-mid']];
  var ALL = TONES.map(function(t) { return t[1]; });

  function greyAt(t) {
    t = Math.min(Math.max(t, 0), 1);
    for (var i = 1; i < STOPS.length; i++) {
      if (t <= STOPS[i][0]) {
        var a = STOPS[i - 1], b = STOPS[i];
        return a[1] + (b[1] - a[1]) * (t - a[0]) / (b[0] - a[0]);
      }
    }
    return STOPS[STOPS.length - 1][1];
  }

  function toneFor(grey) {
    for (var i = 0; i < TONES.length; i++) if (grey < TONES[i][0]) return TONES[i][1];
    return '';
  }

  function paintsBackground(el) {
    var cs = getComputedStyle(el);
    if (cs.backgroundImage !== 'none') return true;
    var m = cs.backgroundColor.match(/[\d.]+/g);
    return !!m && (m.length < 4 || parseFloat(m[3]) >= 0.5);
  }

  // True when nothing between el and the section root paints a background,
  // i.e. the page gradient is what's behind it.
  function onPage(el, root) {
    for (var a = el; a && a !== root.parentElement; a = a.parentElement) {
      if (paintsBackground(a)) return false;
    }
    return true;
  }

  var toned = [];

  function apply() {
    toned.forEach(function(el) { el.classList.remove.apply(el.classList, ALL); });
    toned = [];
    var pageH = document.documentElement.getBoundingClientRect().height || 1;
    // <main> covers sections and plain templates (cart, 404) alike; the
    // footer and other layout sections live outside it.
    var roots = [document.getElementById('main-content')];
    document.querySelectorAll('.shopify-section').forEach(function(s) {
      if (!s.closest('main')) roots.push(s);
    });
    for (var i = 0; i < roots.length; i++) {
      var section = roots[i];
      if (!section) continue;
      // Layout sections that paint their own background (header, bars) keep
      // their look. Inside <main>, onPage() skips the hero and cards per element.
      if (section.tagName !== 'MAIN' && (paintsBackground(section) ||
          (section.firstElementChild && paintsBackground(section.firstElementChild)))) continue;
      var targets = [];
      var walker = document.createTreeWalker(section, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        var el = walker.currentNode.parentElement;
        if (walker.currentNode.textContent.trim() && targets.indexOf(el) === -1) targets.push(el);
      }
      // Icons drawn in currentColor follow the text tone too, as do blocks
      // that opt in with data-tone (e.g. timeline lines and dots).
      section.querySelectorAll('svg').forEach(function(svg) {
        var el = svg.parentElement;
        if (el && targets.indexOf(el) === -1) targets.push(el);
      });
      section.querySelectorAll('[data-tone]').forEach(function(el) {
        if (targets.indexOf(el) === -1) targets.push(el);
      });
      targets.forEach(function(el) {
        if (el.closest('svg, script, style, template') || !onPage(el, section)) return;
        var r = el.getBoundingClientRect();
        if (!r.height) return;
        var tone = toneFor(greyAt((r.top + window.scrollY + r.height / 2) / pageH));
        if (!tone) return;
        el.classList.add(tone);
        toned.push(el);
      });
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function() { queued = false; apply(); });
  }

  apply();
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(document.body);
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function(e) {
    document.addEventListener(e, schedule);
  });
})();
